



















import { Component, Vue } from "vue-property-decorator";

@Component
export default class TabsComponent extends Vue {
    public selectedIndex: number = 0;
    public tabs: any[] = [];

    created() {
        this.tabs = this.$children;
    }

    mounted() {
        this.selectTab(0);
    }

    public selectTab(index: number): void {
        this.selectedIndex = index;

        this.tabs.forEach((tab, i) => {
            tab.isActive = (i === this.selectedIndex)
        })
    }
}
